import React from "react";

/**
 * Tab navigation components for MembersScreen
 */

export const PersonalTabBar = ({
  personalTab = "members",
  onMembersClick,
  onApplicationsClick,
}) => (
  <div className="branch-subtab-container">
    <div className="tab-wrapper">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            type="button"
            className={
              personalTab === "members"
                ? "nav-link active"
                : "nav-link inactive"
            }
            onClick={onMembersClick}
          >
            Find Members &amp; Prospects
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={
              personalTab === "applications"
                ? "nav-link active"
                : "nav-link inactive"
            }
            onClick={onApplicationsClick}
          >
            Find Applications
          </button>
        </li>
      </ul>
    </div>
    <div className="bottom-border"></div>
  </div>
);

export const BranchTabBar = ({
  membersTab = "personal",
  onPersonalClick,
  onBusinessClick,
}) => (
  <div className="branch-tab-container d-flex mb-3">
    <ul className="[ nav nav-tabs ]">
      <li className="[ nav-item ]" key={"personal"}>
        <button
          type="button"
          className={
            membersTab === "personal"
              ? "[ form-subtitle nav-link active ]"
              : "[ form-subtitle nav-link inactive ]"
          }
          data-toggle="tab"
          role="tab"
          aria-controls={"personal"}
          onClick={onPersonalClick}
        >
          Personal Banking
        </button>
        <div className={membersTab === "personal" ? "[ tab-line ]" : ""}></div>
      </li>
      <li className="[ nav-item ]" key={"business"}>
        <button
          type="button"
          className={
            membersTab === "business"
              ? "[ form-subtitle nav-link active ]"
              : "[ form-subtitle nav-link inactive ]"
          }
          data-toggle="tab"
          role="tab"
          aria-controls={"business"}
          onClick={onBusinessClick}
        >
          Business Banking
        </button>
        <div className={membersTab === "business" ? "[ tab-line ]" : ""}></div>
      </li>
    </ul>
  </div>
);
